<template>
    <h5-dialog>
        <template v-slot:header>
            <div class="title text-center m-b">{{ $t('服务条款') }}</div>
        </template>
        <div class="terms-of-service">
            <h1 class="tos-heading">Terms of Service</h1>
            <p class="tos-updated">Last Updated: May 21, 2026</p>

            <p class="tos-intro">
                Welcome to <strong>Elf Trainer: Legend Wars</strong>!
            </p>
            <p>
                These Terms of Service ("Terms") govern your access to and use of the mobile application
                Elf Trainer: Legend Wars (the "Game"), including all related features, content, and services
                operated by STARRIDE INTERACTIVE US TECHNOLOGY LLC ("Company", "we", "us", or "our").
            </p>
            <p>
                By downloading, accessing, or playing the Game, you agree to be bound by these Terms.
                If you do not agree to these Terms, please do not access or play the Game.
            </p>

            <section class="tos-section">
                <h2>1. Account &amp; User Responsibilities</h2>
                <ul class="tos-list">
                    <li>
                        <strong>Account Security:</strong> You are responsible for maintaining the confidentiality
                        of your account information, login details, and all activities that occur under your account.
                    </li>
                    <li>
                        <strong>Prohibited Conduct:</strong> You agree not to engage in cheating, exploiting bugs,
                        using unauthorized third-party software/bots, or harassing other players.
                    </li>
                </ul>
            </section>

            <section class="tos-section">
                <h2>2. In-App Purchases &amp; Virtual Items</h2>
                <ul class="tos-list">
                    <li>
                        <strong>Virtual Currency &amp; Goods:</strong> The Game may include virtual currency, items,
                        or passes. All virtual items are licensed to you, not sold, and have no monetary value or
                        real-world cash equivalent outside the Game.
                    </li>
                    <li>
                        <strong>Final Sale:</strong> All purchases made within the Game (including virtual currency,
                        virtual items, and subscription passes) are final and non-refundable, except as expressly
                        provided in Section 3 below or as required by applicable law.
                    </li>
                </ul>
            </section>

            <section class="tos-section">
                <h2>3. Refund &amp; Return Policy</h2>
                <p>
                    <strong>In-App Purchases via App Stores:</strong> All billing and transactions for in-app
                    purchases are processed directly by official app platform providers (such as the Apple App
                    Store or Google Play Store). Refund requests for in-app purchases must be submitted directly
                    to the respective app platform in accordance with their established refund policies and guidelines:
                </p>
                <ul class="tos-list">
                    <li>
                        <strong>Apple App Store:</strong> Requests must be submitted through
                        reportaproblem.apple.com.
                    </li>
                    <li>
                        <strong>Google Play Store:</strong> Requests must be submitted via Google Play Help or
                        your Google account purchase history.
                    </li>
                </ul>
                <p>
                    <strong>Direct Web / External Purchases:</strong> If applicable, purchases made through official
                    company web portals or authorized direct payment methods are strictly non-refundable once
                    virtual goods, currencies, or services have been credited to your account, unless mandatory
                    local law dictates otherwise.
                </p>
                <p>
                    <strong>Account Action / Terminations:</strong> Violations of these Terms that result in account
                    suspension, ban, or termination will void eligibility for any refunds on unspent virtual items
                    or balances.
                </p>
            </section>

            <section class="tos-section">
                <h2>4. Support &amp; Feedback</h2>
                <p>We appreciate your feedback to help us improve the Game:</p>
                <ul class="tos-list">
                    <li>
                        <strong>Feedback Usage:</strong> Any feedback, comments, or suggestions you provide regarding
                        the Game may be used by us without restriction or obligation to you.
                    </li>
                    <li>
                        <strong>Customer Support:</strong> If you have questions, bug reports, payment inquiries, or
                        account support issues, please contact us via the in-game support channel or through our
                        official contact email below.
                    </li>
                </ul>
            </section>

            <section class="tos-section">
                <h2>5. Governing Law &amp; Dispute Resolution</h2>
                <ul class="tos-list">
                    <li>
                        <strong>Governing Law:</strong> These Terms, and any dispute, claim, or controversy arising
                        out of or relating to these Terms or your use of the Game, shall be governed by and construed
                        in accordance with the laws of the State of California, United States, without regard to its
                        conflict of law principles.
                    </li>
                    <li>
                        <strong>Jurisdiction:</strong> You agree that any legal action or proceeding arising out of
                        or relating to these Terms or the Game shall be brought exclusively in the state or federal
                        courts located in California, United States, and you hereby consent and submit to the personal
                        jurisdiction and venue of such courts.
                    </li>
                </ul>
            </section>

            <section class="tos-section">
                <h2>6. Official Contact Information</h2>
                <ul class="tos-list tos-contact">
                    <li><strong>Operating Entity:</strong> STARRIDE INTERACTIVE US TECHNOLOGY LLC</li>
                    <li><strong>Game Title:</strong> Elf Trainer: Legend Wars</li>
                    <li><strong>Customer Support Email:</strong> ryanwin1152@gmail.com</li>
                    <li><strong>Official Website:</strong> https://www.starride.top/</li>
                    <li>
                        <strong>Corporate Address:</strong> 1401 21st St Ste R, Sacramento, CA 95811, United States
                    </li>
                </ul>
            </section>
        </div>
        <template v-slot:footer>
            <button class="btn btn-primary btn-block" @click="handleClose">{{ $t('关闭') }}</button>
        </template>
    </h5-dialog>
</template>

<script>
import H5Dialog from '../H5Dialog'

export default {
    name: 'TermsOfService1123039',
    components: { H5Dialog },
    methods: {
        handleClose() {
            this.$emit('close')
        },
    },
}
</script>

<style scoped>
.terms-of-service {
    font-size: 14px;
    line-height: 1.7;
    color: #333;
    word-break: break-word;
}

.tos-heading {
    font-size: 24px;
    font-weight: 700;
    color: #1a1a1a;
    text-align: center;
    margin-bottom: 4px;
    padding-bottom: 12px;
    border-bottom: 2px solid #1890ff;
}

.tos-updated {
    font-size: 13px;
    color: #666;
    text-align: center;
    margin-bottom: 16px;
}

.tos-intro {
    font-weight: 600;
}

.tos-section {
    margin-bottom: 20px;
}

.tos-section h2 {
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 1px solid #e8e8e8;
}

.tos-list {
    margin: 8px 0 8px 18px;
    padding-left: 0;
}

.tos-list li {
    margin-bottom: 6px;
    list-style-type: disc;
}

.tos-contact li {
    list-style-type: none;
    margin-bottom: 4px;
}
</style>
